import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/graphql'
import { Schema } from '../schema'
import { Data, toDTO, UPDATE_PERFORMANCE_REPORT } from './api'
import { UseUpdatePerformanceReport } from './types'

export const useUpdatePerformanceReport = (): UseUpdatePerformanceReport => {
  const { t } = useTranslation('features/performance')
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState<boolean>(false)
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const [mutate] = useMutation(UPDATE_PERFORMANCE_REPORT, {
    onCompleted: ({ updateWorkspace: { errors } }: Data): void => {
      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), {
          variant: 'error',
        })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), {
          variant: 'success',
        })
      }
    },
    onError: (): void => setLoading(false),
    refetchQueries: ['getPerformanceReport'],
  })

  const update = (data: Schema) => {
    setLoading(true)

    return mutate({
      variables: {
        input: toDTO(data),
      },
    })
  }

  return {
    errors,
    loading,
    update,
  }
}
